import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilService } from '../../shared/services';
import { PaymentUtilService } from '../payment/services';


@Component({
  selector: 'app-exit-intent-new',
  templateUrl: './exit-intent-new.component.html',
  styleUrls: ['./exit-intent-new.component.scss']
})
export class ExitIntentNewComponent implements OnInit {

  @Input() fundraiser;
  @Output() action = new EventEmitter();
  currency;
  isFundraiserEnded: boolean;

  constructor(
    private paymentUtil: PaymentUtilService,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.paymentUtil.paymentCurrency.subscribe(res => {
      if (res) {
        this.currency = res;
      }
    });
    this.isFundraiserEnded = this.util.checkFundraiserStatus(this.fundraiser?.status_flag, this.fundraiser?.end_date);
  }

  handleCloseAndSendEvent(event) {
    this.action.emit(event);
  }

}
